import React from 'react';
export function StickyAlertBar() {
  return <div className="sticky top-0 z-50 bg-urgency/90 backdrop-blur-sm text-white py-3 px-4 text-center font-body font-semibold shadow-soft" data-id="element-176">
      <p className="text-sm md:text-base tracking-wide" data-id="element-177">
        +2000 descargas —{' '}
        <span className="underline decoration-white/50 underline-offset-2" data-id="element-178">
          Oferta por tiempo limitado
        </span>{' '}
        ⏰
      </p>
    </div>;
}